import { css } from "@emotion/react";
import type { SVGProps } from "react";
import { forwardRef } from "react";

import type { Point } from "../../types";

type Props = { width: number; height: number; positionOrigin: Point } & SVGProps<SVGSVGElement>;

export const SvgCanvas = forwardRef<SVGSVGElement, Props>(({ positionOrigin, width, height, ...props }, ref) => {
  const viewboxStartX = positionOrigin.x * -1;
  const viewboxStartY = positionOrigin.y * -1;
  return (
    <svg
      {...props}
      viewBox={`${viewboxStartX} ${viewboxStartY} ${width} ${height}`}
      css={css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
      `}
      ref={ref}
    />
  );
});
SvgCanvas.displayName = "SvgCanvas";
